module.exports = __webpack_public_path__ + "img/icon_saved.1e9fc779.svg";